export default __webpack_public_path__ + "static/media/profile-user_white.4dd32ea3.svg";